<div #navmenu fxLayout="column" fxLayoutAlign="start stretch">
  <button mat-raised-button type="button" *ngFor="let item of FilteredItems" [attr.id]="'NavBtn_' + item.ButtonIndex" [color]="item.Active ? 'accent' : null" fxLayout="row" fxLayoutAlign="space-between center" (click)="HandleItemClick(item)">
    <mat-icon *ngIf="item.MenuIcon">{{item.MenuIcon}}</mat-icon>
    <span>{{item.MenuText}}</span>
  </button>
</div>


// WEBPACK FOOTER //
// ./src/app/ui/navmenu/navmenu.component.html